<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Editar Consumo</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="fechaConsumo"
                :value="fechaConsumo"
                label="Fecha Consumo *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="descripcion"
                prepend-icon="mdi-account"
                label="Descripcion"
                dense
                maxlength="200"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="total"
                prepend-icon="mdi-currency-usd"
                :rules="totalRules"
                label="Importe *"
                @blur="toFixed"
                @keypress="onlyNumber"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="modificarConsumo"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
:deep(.checkbox) {
  .v-input--checkbox {
    margin-top: 0.6rem;
    padding-top: 0;
    &:first-child {
      margin-left: 1rem;
    }
    .v-input--selection-controls__input {
      margin-right: 2px;
    }
  }
}
</style>
<script>
import axios from "@/axios-auth";
import moment from "moment";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    fechaConsumo: null,
    descripcion: "",
    total: null,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    totalRules: [
      (v) => !!v || "Dato obligatorio",
      (v) => v > 0 || "El total debe ser mayor a 0",
    ],
  }),
  props: {
    visible: { required: false },
    idConsumo: { required: false },
  },
  computed: {
    show: {
      get() {
        if (this.visible) this.buscarDatosConsumo();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close", false);
        }
      },
    },
  },
  methods: {
    modificarConsumo() {
      if (moment(this.fechaConsumo).isBefore(moment("1900-01-01"))) {
        this.showAlert({
          icon: "warning",
          title: "La fecha del consumo debe ser mayor o igual al 01/01/1900.",
          timer: 2500,
          vm: this,
        });
        return;
      }
      this.$swal({
        title: "Modificar consumo",
        text: "¿Desea modificar el consumo?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosConsumo = {
            fecha: this.fechaConsumo,
            idTurno: this.idTurno,
            total: this.total,
            descripcion: this.descripcion,
            usuario: this.$store.state.usuario.usuario,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idConsumo: this.idConsumo,
          };
          let self = this;
          axios
            .post("/Caja/ModificarConsumo", datosConsumo)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              document.getElementsByClassName(
                "v-dialog--active",
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title: "Consumo modificado.",
                vm: self,
                timer: 2000,
              });
              self.$emit("close", true);
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El consumo no pudo ser modificado.",
                vm: this,
                timer: 2000,
              });
            });
        }
      });
    },

    buscarDatosConsumo() {
      const consumoData = {
        idConsumo: this.idConsumo,
      };

      let self = this;

      axios
        .get("/Caja/BuscarDatosConsumo?", {
          params: {
            idConsumo: consumoData.idConsumo,
          },
        })
        .then((response) => {
          self.fechaConsumo = response.data.fecha.substring(0, 10);
          self.descripcion = response.data.descripcion;
          self.total = parseFloat(response.data.total).toFixed(2);
          self.idTurno = response.data.idTurno;
        })
        .catch((error) => {});
    },

    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    toFixed() {
      if (isNaN(parseFloat(this.total)))
        this.total = parseFloat(0.0).toFixed(2);
      else this.total = parseFloat(this.total).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    vaciarModels() {
      this.descripcion = "";
      this.total = "";
      this.fechaConsumo = null;
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
  },
};
</script>
